const initialState = [
  {
    livetvLockedData: [],
    moviesLockedData: [],
    seriesLockedData: [],
  },
];

const prantalControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LIVE_TV_LOCKED_IDS":
      return {
        ...state,
        livetvLockedData: action.payload,
      };
    case "MOVIES_LOCKED_IDS":
      return {
        ...state,
        moviesLockedData: action.payload,
      };
    case "SERIES_LOCKED_IDS":
      return {
        ...state,
        seriesLockedData: action.payload,
      };
    default:
      return state;
  }
};

export default prantalControlReducer;
